<template>
  <el-dialog :visible.sync="show" width="500px">

    <el-row>
      <el-col :span="12" style="margin: 10px 0;">

        <span class="switch-span">司机上线播报:</span>
        <el-switch v-model="broadcast_value.driver_online" active-color="#13ce66" inactive-color="#ccc" @change="broadcastChange">
        </el-switch>

      </el-col>

      <el-col :span="12" style="margin: 10px 0;">

        <span class="switch-span">司机下线播报:</span>
        <el-switch v-model="broadcast_value.driver_offline" active-color="#13ce66" inactive-color="#ccc" @change="broadcastChange">
        </el-switch>

      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12" style="margin: 10px 0;">

        <span class="switch-span">新订单播报:</span>
        <el-switch v-model="broadcast_value.need_driver" active-color="#13ce66" inactive-color="#ccc" @change="broadcastChange">
        </el-switch>
      </el-col>


    </el-row>


    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">关闭</el-button>
    </span>

  </el-dialog>
</template>
<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;


      },
    },
    created() {
      _this = this;
    },
    data() {
      return {

        show: false,

        broadcast_value:JSON.parse(localStorage.getItem('broadcast_value')),


      };
    },

    methods: {

      broadcastChange(){
        localStorage.setItem('broadcast_value',JSON.stringify(_this.broadcast_value))
      }

    },
  };
</script>
<style scoped>
  .switch-span{
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 5px;
  }
</style>